import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'
import TruncatedText from '../../../Common/TruncatedText'

interface BusinessRulesLabelProps {
    text: string
}
export const BusinessRulesLabel = (
    props: BusinessRulesLabelProps,
): ReactElement => {
    const { text } = props
    return (
        <>
            <Box sx={{ width: '40%' }}>
                <TruncatedText
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                    text={text}
                />
            </Box>
            <Box>
                <Typography
                    sx={{
                        marginX: '10px',
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                >
                    :
                </Typography>
            </Box>
        </>
    )
}

export default BusinessRulesLabel
